export default __webpack_public_path__ + "42fd127ff2aa948be806712e322e8c89.png";